const utils = {};

/**
 * Create a name string accounting for possible null values.
 *
 * @param {string} firstName
 * @param {string} lastName
 * @returns {string}
 */
utils.getFullName = (firstName, lastName) => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  return firstName || lastName || '';
};

export default utils;
